import { motion } from "framer-motion";
import SectionAtmosphere from "@/components/SectionAtmosphere";
import atmosphereHow from "@/assets/atmosphere-howitworks.jpg";
import { lqipFor } from "@/generated/atmospheric-lqip";
import { riseFade } from "@/lib/motion";

const phases = [
  {
    number: "01",
    title: "A quiet minute in the morning",
    description: "Under 45 seconds. Four soft taps, sleep, energy, stress, focus. No streaks, no shame, no lecture. Just a signal from you, to you.",
  },
  {
    number: "02",
    title: "Myelina reads the shape of your day",
    description: "She compares this morning to your own history, never a stranger's baseline, and finds the rhythm you're already living.",
  },
  {
    number: "03",
    title: "You see the hours worth protecting",
    description: "A calm Energy Map of likely peaks, tender dips, and windows to guard. Move meetings. Move rest. Move with your body, not against it.",
  },
  {
    number: "04",
    title: "One clear line. Then move on.",
    description: "Two or three options become one calm decision. Fatigue stops holding the pen. You get your day back.",
  },
];


const HowItWorks = () => (
  <SectionAtmosphere
    id="how-it-works"
    ariaLabelledBy="how-heading"
    src={atmosphereHow}
    optimizedBase="/opt/atmosphere-howitworks"
    lqip={lqipFor(atmosphereHow)}
    origin="bottom left"
    glow="left"
    tone="warm"
    className="py-28 sm:py-36"
  >
    <div className="container mx-auto px-6 sm:px-10 lg:px-16 max-w-6xl">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-10% 0px" }}
        variants={riseFade}
        className="text-center space-y-6 mb-20"
      >
        <div className="eyebrow justify-center mx-auto">How it works</div>
        <h2 id="how-heading" className="font-display text-foreground text-display-xl mx-auto max-w-3xl">
          Four quiet steps. <span className="italic text-primary">One calmer day.</span>
        </h2>
        <p className="lead-italic max-w-2xl mx-auto" style={{ fontSize: "clamp(1.125rem, 1.8vw, 1.375rem)" }}>
          Notice less. Let Myelina hold the pattern-finding, so the day stops surprising you.
        </p>
      </motion.div>


      <div className="grid md:grid-cols-2 gap-x-12 gap-y-16">
        {phases.map((phase, i) => (
          <motion.div
            key={phase.number}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-10% 0px" }}
            variants={riseFade}
            transition={{ delay: i * 0.06 }}
            className="relative pl-12"
          >
            <span
              aria-hidden="true"
              className="absolute -left-2 -top-6 font-display text-primary/15 select-none pointer-events-none"
              style={{ fontSize: "clamp(4rem, 9vw, 7rem)", lineHeight: 1 }}
            >
              {phase.number}
            </span>
            <h3 className="font-display text-display-md text-foreground relative leading-tight mb-2">{phase.title}</h3>
            <p className="text-muted-foreground leading-[1.75] mt-5 max-w-md">{phase.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </SectionAtmosphere>
);

export default HowItWorks;
